"use strict";
/* tslint:disable: variable-name */
Object.defineProperty(exports, "__esModule", { value: true });
function solve(rootFunction, initialGuess, _errorTolerance, step) {
    // Iteratively find using Secant method
    var valueToFind = 0;
    var x1 = 0;
    var x2 = 0;
    var x3 = 0;
    var y1 = 0;
    var y2 = 0;
    var iter = 1;
    var eps = 1e-8;
    var resid = 999;
    while ((iter <= 3 || (!isNaN(resid) && !isInfinity(valueToFind) && Math.abs(resid) > eps) && iter < 100)) {
        if (iter === 1) {
            x1 = initialGuess;
            valueToFind = x1;
        }
        if (iter === 2) {
            x2 = x1 + step;
            valueToFind = x2;
        }
        if (iter > 2) {
            valueToFind = x2;
        }
        // Error between target and actual
        resid = rootFunction(valueToFind);
        if (iter === 1) {
            y1 = resid;
        }
        if (iter > 1) {
            y2 = resid;
            x3 = x2 - y2 / (y2 - y1) * (x2 - x1);
            y1 = y2;
            x1 = x2;
            x2 = x3;
        }
        iter = iter + 1;
    }
    if (iter >= 100) {
        throw new Error("Secant method did not converge.");
    }
    if (isNaN(valueToFind) || isInfinity(valueToFind)) {
        throw new Error("Secant method yielded invalid value.");
    }
    return valueToFind;
}
exports.solve = solve;
function isInfinity(value) {
    return value === Number.POSITIVE_INFINITY || value === Number.NEGATIVE_INFINITY;
}
